import { render, staticRenderFns } from "./CentralPedidosView.vue?vue&type=template&id=ba74366c&"
import script from "./CentralPedidosView.vue?vue&type=script&lang=js&"
export * from "./CentralPedidosView.vue?vue&type=script&lang=js&"
import style0 from "./CentralPedidosView.vue?vue&type=style&index=0&id=ba74366c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports